export default function BankCard({ color, ...props }) {
	return <svg width="15" height="11" viewBox="0 0 15 11" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
		<path
			d="M0.5 3.96154V8.5C0.5 9.60457 1.39543 10.5 2.5 10.5H12.5C13.6046 10.5 14.5 9.60457 14.5 8.5V3.96154M0.5 3.96154V2.5C0.5 1.39543 1.39543 0.5 2.5 0.5H12.5C13.6046 0.5 14.5 1.39543 14.5 2.5V3.96154M0.5 3.96154H14.5M4.06923 7.67949H5.33077C5.7556 7.67949 6.1 7.33509 6.1 6.91026C6.1 6.48542 5.7556 6.14103 5.33077 6.14103H4.06923C3.6444 6.14103 3.3 6.48542 3.3 6.91026C3.3 7.33509 3.6444 7.67949 4.06923 7.67949Z"
			stroke={color}
		/>
	</svg>
}